import { motion } from "framer-motion";
import resumePDF from "../assets/Ebin_Benny_Resume.pdf";
import {
  SiHtml5,
  SiCss3,
  SiJavascript,
  SiPhp,
  SiLaravel,
  SiReact,
  SiTailwindcss,
  SiNodedotjs,
  SiMysql,
  SiKotlin,
  SiSwift,
  SiGit,
} from "react-icons/si";
import { TbApi } from "react-icons/tb";
import { FaDownload } from "react-icons/fa";

const skills = [
  { name: "HTML", type: "Language", icon: <SiHtml5 />, color: "#e34f26" },
  { name: "CSS", type: "Language", icon: <SiCss3 />, color: "#1572b6" },
  { name: "JavaScript", type: "Language", icon: <SiJavascript />, color: "#f7df1e" },
  { name: "PHP", type: "Language", icon: <SiPhp />, color: "#777bb4" },
  { name: "Laravel", type: "Framework", icon: <SiLaravel />, color: "#ff2d20" },
  { name: "React JS", type: "Framework", icon: <SiReact />, color: "#61dafb" },
  { name: "Tailwind CSS", type: "Framework", icon: <SiTailwindcss />, color: "#38bdf8" },
  { name: "Node JS", type: "Runtime", icon: <SiNodedotjs />, color: "#3c873a" },
  { name: "MySQL", type: "Database", icon: <SiMysql />, color: "#4479a1" },
  { name: "REST APIs", type: "Backend", icon: <TbApi />, color: "#a78bfa" },
  { name: "Kotlin", type: "Language", icon: <SiKotlin />, color: "#7f52ff" },
  { name: "Swift", type: "Language", icon: <SiSwift />, color: "#f05138" },
  { name: "Git & GitHub", type: "Tools", icon: <SiGit />, color: "#f05032" },
];

export default function Resume() {
  return (
    <section className="relative py-24 px-5 md:px-10 overflow-hidden">
      <div className="relative container mx-auto max-w-6xl">
        {/* Section Title */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <p className="text-violet-400 text-sm font-medium tracking-widest uppercase mb-2">
            Tools & Technologies
          </p>
          <h2 className="text-3xl md:text-4xl font-bold grad-text">
            My Professional Skills
          </h2>
        </motion.div>

        {/* Skills Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5 mb-16">
          {skills.map((skill, i) => (
            <motion.div
              key={skill.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.35, delay: (i % 4) * 0.05 }}
              className="glass rounded-2xl p-5 flex items-center gap-4 hover:scale-105 hover:border-violet-400/40 transition-all"
            >
              <span
                className="text-3xl sm:text-4xl flex-shrink-0"
                style={{ color: skill.color }}
              >
                {skill.icon}
              </span>
              <div className="min-w-0">
                <p className="font-semibold text-sm sm:text-base truncate">
                  {skill.name}
                </p>
                <p className="text-xs text-gray-400">{skill.type}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Education & Experience */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-14">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="glass rounded-2xl p-7"
          >
            <h3 className="text-xl font-semibold grad-text mb-4">Education</h3>
            <ul className="text-gray-300 space-y-2 text-sm">
              <li>▹ Bachelor's Degree in Computer Science</li>
              <li>▹ Master's Degree in Information Technology</li>
              <li>▹ Strong foundation in programming & problem-solving</li>
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="glass rounded-2xl p-7"
          >
            <h3 className="text-xl font-semibold grad-text mb-4">Experience</h3>
            <ul className="text-gray-300 space-y-2 text-sm">
              <li>▹ Full-stack web development using Laravel & React</li>
              <li>▹ Backend and mobile development using Kotlin & Swift</li>
              <li>▹ Built dashboards, APIs, and dynamic websites</li>
            </ul>
          </motion.div>
        </div>

        {/* Resume Download */}
        <div className="text-center">
          <a
            href={resumePDF}
            download
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-violet-500 to-blue-500 text-white font-semibold rounded-xl shadow-lg shadow-violet-500/25 hover:scale-105 transition-transform"
          >
            <FaDownload /> Download Resume (PDF)
          </a>
        </div>
      </div>
    </section>
  );
}
